import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../generic/hooks/useAuth";
import { useReadMemory } from "../generic/hooks/useReadMemory";
import MemoryType from "../../service/memory/enum/MemoryType";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const isLoggedIn = useAuth();
  const isAuthenticated = useReadMemory(MemoryType.AUTH);

  useEffect(() => {
    if (!isLoggedIn || !isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, isLoggedIn, navigate]);

  return <>{isLoggedIn && children}</>;
};

export default PrivateRoute;
